import React, { Suspense } from 'react';
import { Link } from 'react-router-dom';
import { AuthCheckAdmin } from '../../../../Utils/AuthCheck/AdminCheck.auth';
import HelmetHelper from '../../../../Components/PageHelmet/HelmetHelper.component';
import CompanyDataProvider from '../../../../Utils/Companies/CompanyDataProvider';
import FormLoading from '../../../../Components/LoadingPages/LoadingForm.component';
import { useParams } from 'react-router-dom';
import { CompanyHomeContainer, CompanyNav } from './CompanyHome.styles';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import CompanyData from './CompanyData.component';

const CompanyAdminHome = () => {
  const { id } = useParams();
  return (
    <AuthCheckAdmin>
      <Suspense fallback={<p>Loading page...</p>}>
        <HelmetHelper
          title="Company Homepage | Admin"
          description="Company homepage for admin viewing details about company"
        />
      </Suspense>
      <CompanyDataProvider id={id} loadingComponent={FormLoading}>
        {(company) => {
          return (
            <CompanyHomeContainer>
              <BreadCrumbs
                one="Admin Dashboard"
                oneLink="/admin"
                two="Company Info"
              />
              <header>
                {company?.company?.[0]?.logo && (
                  <img
                    src={company?.company?.[0]?.logo}
                    alt="Company Logo"
                    className="company-logo"
                  />
                )}
                <h3>{company?.company?.[0]?.companyName || 'Company Name'}</h3>
              </header>
              <CompanyNav>
                <Link to={`/admin/company/edit/${id}`} className="nav-link">
                  Edit Company
                </Link>
                |
                <Link
                  to={`/admin/company/employees/${id}`}
                  className="nav-link"
                >
                  Employees & Managers
                </Link>
                |
                <Link
                  to={`/admin/company/purchase-history/${id}`}
                  className="nav-link"
                >
                  Purchase History
                </Link>
              </CompanyNav>
              <CompanyData c={company.company[0]} address={company.address} />
            </CompanyHomeContainer>
          );
        }}
      </CompanyDataProvider>
    </AuthCheckAdmin>
  );
};

export default CompanyAdminHome;
